import React, { useEffect } from 'react'
import SpaceIcon from 'components/spaces/SpaceIcon'
import useStore from 'state/knovStore'
import styles from 'components/shared/loadingscreen.module.scss'
import { markStartupMetric } from 'lib/startupMetrics'

export default function LoadingScreen({ spaceId = undefined }) {
    const space = useStore.getState().getSpace(spaceId)
    const hasSpaceIcon = Boolean(space)

    useEffect(() => {
        markStartupMetric('loading-screen-mounted', { hasSpaceIcon })
    }, [hasSpaceIcon])

    return (
        <>
            <div className={styles.loading} data-testid="app-loading-screen">
                {space ? (
                    <SpaceIcon
                        space={space}
                        contextStyles={styles.loadingSpaceIcon}
                        initialStyles={styles.initialStyles}
                    />
                ) : (
                    <i className="fa fa-circle-o-notch fa-spin fa-lg" />
                )}
            </div>
        </>
    )
}
